import { useMemo, useState } from "react";
import { ChevronDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useFetch } from "@/hooks/useFetch";

// Item codes flagged "serial tracked" in the Item Master
export function useSerialFlags(codes) {
  const key = useMemo(() => [...new Set((codes || []).filter(Boolean))].sort().join(","), [codes]);
  const { data } = useFetch(key ? `/items/serial-flags?codes=${encodeURIComponent(key)}` : null);
  return new Set(data || []);
}

const F = [["serial_no", "Serial no.", "w-36"], ["mfr_serial_no", "Mfr serial", "w-32"], ["model_no", "Model", "w-28"], ["remarks", "Remarks", "flex-1 min-w-[120px]"]];

// One row per dispatched unit (optional): serial, manufacturer serial, model, remarks - collapsible
export function SerialCapture({ qty, rows, onChange, tracked, testid }) {
  const [open, setOpen] = useState(false);
  const n = Math.max(0, Math.min(Number.isInteger(Number(qty)) ? Number(qty) : 0, 200));
  if (!n) return tracked ? <p className="text-[11px] text-slate-500">Serial-tracked: dispatch whole units to enter serials (optional)</p> : null;
  const list = Array.from({ length: n }, (_, i) => (rows || [])[i] || {});
  const set = (i, k, v) => onChange(list.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const filled = list.filter((r) => (r.serial_no || "").trim()).length;
  return (
    <div className="rounded bg-slate-50 p-2" data-testid={testid}>
      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} className="flex w-full items-center gap-2 text-left text-[10px] font-semibold uppercase tracking-wider text-slate-500" data-testid={`${testid}-toggle`}>
        Serial numbers (optional){tracked ? " - serial-tracked item" : ""}<span className="font-normal normal-case tracking-normal">{filled} of {n} entered</span>
        <ChevronDown className={`ml-auto h-3.5 w-3.5 transition-transform ${open ? "" : "-rotate-90"}`} />
      </button>
      {open && <div className="mt-1 space-y-1">{list.map((r, i) => (
        <div key={`unit-${i + 1}`} className="flex flex-wrap gap-1">
          <span className="w-5 pt-1.5 text-[10px] text-slate-400">{i + 1}</span>
          {F.map(([k, l, w]) => <Input key={k} className={`h-7 text-xs ${w}`} placeholder={l} value={r[k] || ""}
            onChange={(e) => set(i, k, e.target.value)} data-testid={`${testid}-${k}-${i}`} />)}
        </div>
      ))}</div>}
    </div>
  );
}

export const cleanSerials = (rows) => (rows || []).filter((r) => (r.serial_no || "").trim());
